import React, { Component } from 'react';
import CoinDetailTableHeader from "./CoinDetailTableHeader";
import CoinDetailRow from "./CoinDetailRow";

class CoinDetailTable extends Component {
    render() {
        return (
            <table className="cg-table cg-coin-detail-table table table-striped table-hover">
                <CoinDetailTableHeader {...this.props} />
                <CoinDetailRow {...this.props} />
            </table>
        );
    }
}

export default CoinDetailTable;



// WEBPACK FOOTER //
// ./src/CoinDetailTable.js